export const OPPORTUNITY_STATUSES = {
  published: {
    id: "published",
    icon: "check",
    color: "primary"
  },
  open: {
    id: "open",
    icon: "lock",
    color: "grey-medium"
  },
  finished: {
    id: "finished",
    icon: "lock",
    color: "error"
  }
};
